import { render, staticRenderFns } from "./RecSenha.vue?vue&type=template&id=34dbd873&scoped=true&"
import script from "./RecSenha.vue?vue&type=script&lang=js&"
export * from "./RecSenha.vue?vue&type=script&lang=js&"
import style0 from "./RecSenha.vue?vue&type=style&index=0&id=34dbd873&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dbd873",
  null
  
)

export default component.exports